import { render, staticRenderFns } from "./FacilityForm.vue?vue&type=template&id=3b394bf9&"
import script from "./FacilityForm.vue?vue&type=script&lang=js&"
export * from "./FacilityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports